// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"l0-z"};